import React, { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './HeroSection.css';

import bannerImg from '../assets/banner.webp';
import bannerImg1 from '../assets/banner-1.webp';
import bannerImg2 from '../assets/banner-2.webp';
import bannerImg3 from '../assets/banner-3.webp';
import bannerImg4 from '../assets/banner-4.webp';

const images = [
  bannerImg,
  bannerImg1,
  bannerImg2,
  bannerImg3,
  bannerImg4,
];

function HeroSection() {
  const [loadedImages, setLoadedImages] = useState(
    Array(images.length).fill(false)
  );

  const handleImageLoad = (index) => {
    const updated = [...loadedImages];
    updated[index] = true;
    setLoadedImages(updated);
  };

  return (
    <div className="hero-carousel-container">

      {/* Welcome Content */}
      <div className="carousel-overlay enhanced-welcome">

        <div className="welcome-eyebrow">
          <span className="eyebrow-line"></span>
          <span>WELCOME TO</span>
          <span className="eyebrow-line"></span>
        </div>

        <h2 className="welcome-title animate__animated animate__fadeInUp">
          Sri Sri Radha
          <br />
          <span className="temple-name">
            Madan Mohan Temple
          </span>
        </h2>

        <div className="welcome-divider">
          <span></span>
          <b>✦</b>
          <span></span>
        </div>

        <p className="welcome-subtitle animate__animated animate__fadeInUp animate__delay-1s">
          <strong>Founder-Acharya</strong>
          <br />
          His Divine Grace A. C. Bhaktivedanta Swami Prabhupada
        </p>

      </div>

      {/* Carousel */}
      <Carousel
        fade
        controls={true}
        indicators={true}
        interval={5000}
        pause={false}
      >
        {images.map((img, index) => (
          <Carousel.Item key={index}>

            <div className="carousel-image-wrapper">

              <img
                src={img}
                alt={`Sri Sri Radha Madan Mohan Temple ${index + 1}`}
                className={`carousel-image ${
                  loadedImages[index] ? 'visible' : 'hidden'
                }`}
                loading={index === 0 ? 'eager' : 'lazy'}
                onLoad={() => handleImageLoad(index)}
              />

              {/* Cinematic image overlay */}
              <div className="hero-image-overlay"></div>

            </div>

          </Carousel.Item>
        ))}
      </Carousel>

    </div>
  );
}

export default HeroSection;